import { CacheService } from "../services/CacheService";
import { SocketService } from "../services/SocketService";
import { EventBus } from "../core/EventBus";
import { GZIPService } from "../services/GZIPService";

export class BasePage {

    constructor() {

        this.ws = new SocketService(window.appData?.wsUrl, window.appData?.token);
        this.bus = new EventBus();
    }

    initResource({ controller, event, cacheKey, payload }) {

        let cached = false; //CacheService.get(cacheKey);
        if (cached) {

            controller.model.setState({
                data: GZIPService.decode(cached)
            });
            return;
            
        }

        const handler = (response) => {
            CacheService.set(cacheKey, response.data, response.expired);

            controller.model.setState({
                data: GZIPService.decode(response.data)
            });

            this.bus.off(event, handler);
        };

        this.bus.on(event, handler);
        this.ws.send(event, payload);
    }
}
